import React from 'react';
import { IconProps } from '.';

const SvgDocumentCharts = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M9.5 15.75v-9H11v9H9.5ZM6.5 15.75V11H8v4.75H6.5ZM12.5 9v6.75H14V9h-1.5Z' />
      <path fill={color} fillRule='evenodd' d='M2.5 2H18v17.5H2.5V2ZM4 3.5V18h12.5V3.5H4Z' clipRule='evenodd' />
      <path fill={color} d='M19.5 6.75V21H8.25v1.5H21V6.75h-1.5Z' />
    </svg>
  );
};

export default SvgDocumentCharts;
